import { render, staticRenderFns } from "./AddInstructionReview.vue?vue&type=template&id=5077aa82&scoped=true&"
import script from "./AddInstructionReview.vue?vue&type=script&lang=ts&"
export * from "./AddInstructionReview.vue?vue&type=script&lang=ts&"
import style0 from "./AddInstructionReview.vue?vue&type=style&index=0&id=5077aa82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5077aa82",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
